import React from 'react'
import { icon } from '../../../services/icon'

const TimeSlots = ({ block }) => {
    return (
        <div className="baseocom-mb-4">
            {block?.content && (
                <div className="baseocom-block-item">
                    {icon('time-slots')}
                    <p>{block?.content}</p>
                </div>
            )}
        </div>
    )
}

export default TimeSlots
